import { Box, Checkbox, Text } from '@bechtel/gds';
import { BlockStatusCode, Scalars } from '@bechtel/types';
import { Trans, t } from '@lingui/macro';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some } from 'lodash';
import React, { Fragment } from 'react';
import { ListSelectionStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { useLingui } from '@lingui/react';

export interface BlockStatusProps {
  codeI18n: BlockStatusCode;
  label: Scalars['String'];
}

export const blockStatusList = [
  { codeI18n: BlockStatusCode.BLOCK_OPENED, label: t`Open` },
  { codeI18n: BlockStatusCode.BLOCK_RESOLVED, label: t`Closed` },
];

const BlockStatusList: React.FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();
  return (
    <Fragment>
      <Box data-testid="success" flexDirection={{ sm: 'column' }}>
        {/*Todo add milestone query to load list  */}

        <SubListSelectionStyled
          onClick={() => {
            if (form.values.blockStatus?.length !== blockStatusList.length) {
              form.setFieldValue('blockStatus', blockStatusList);
            } else {
              form.setFieldValue('blockStatus', []);
            }
          }}
        >
          <Box alignItems={{ sm: 'center' }}>
            <Box mr={{ sm: '500' }}>
              <Checkbox
                checked={form.values.blockStatus?.length === blockStatusList.length}
                indeterminate={
                  form.values.blockStatus?.length > 0 && form.values.blockStatus?.length < blockStatusList.length
                }
                readOnly
              />
            </Box>
            <Text size="400" weight="600" color="bechtel.grey.1000">
              <Trans>Block Status</Trans>
            </Text>
          </Box>
          {form.values.blockStatus && form.values.blockStatus.length > 0 && (
            <Text size="400" color="bechtel.grey.1000">
              {form.values.blockStatus.length} <Trans>Selected</Trans>
            </Text>
          )}
        </SubListSelectionStyled>
        <FieldArray name="blockStatus">
          {(arrayHelpers) => {
            return (
              <>
                {blockStatusList &&
                  blockStatusList.map((status) => {
                    return (
                      <ListSelectionStyled
                        key={status.codeI18n}
                        data-testid={`block-card-search-canvas-Block-status-${status.codeI18n}`}
                        onClick={() => {
                          const selected = findIndex(form.values.blockStatus, (item: BlockStatusProps) => {
                            return item.codeI18n === status.codeI18n;
                          });
                          if (selected !== -1) {
                            arrayHelpers.remove(selected);
                          } else {
                            arrayHelpers.push(status);
                          }
                        }}
                      >
                        <Box mr={{ sm: '500' }}>
                          <Checkbox
                            checked={some(form.values.blockStatus, (item: BlockStatusProps) => {
                              return item.codeI18n === status.codeI18n;
                            })}
                            readOnly
                          />
                        </Box>
                        <Text size="400" color="bechtel.grey.1000">
                          {i18n._(status.label)}
                        </Text>
                      </ListSelectionStyled>
                    );
                  })}
              </>
            );
          }}
        </FieldArray>
      </Box>
    </Fragment>
  );
};

export default BlockStatusList;
